import 'css-chunksrc/client/scenes/strategicAxisEdition/form/styles.scss';export default {
  "form": "_form_uvuv8_1",
  "group": "_group_uvuv8_5",
  "row": "_row_uvuv8_9",
  "horizontalRow": "_horizontalRow_uvuv8_20",
  "label": "_label_uvuv8_26",
  "description": "_description_uvuv8_32",
  "root": "_root_uvuv8_36",
  "listRoot": "_listRoot_uvuv8_40",
  "icon": "_icon_uvuv8_48",
  "input": "_input_uvuv8_57",
  "opened": "_opened_uvuv8_76",
  "list": "_list_uvuv8_40",
  "option": "_option_uvuv8_95",
  "selected": "_selected_uvuv8_103"
};